import LoadingSpinner from '../LoadingSpinner';
import { Logo } from '../../assets';
import React from 'react';
import styles from './FullscreenLoader.module.scss';

interface IFullscreenLoaderProps {
  withLogo?: boolean | undefined;
}

export default function FullscreenLoader({ withLogo }: IFullscreenLoaderProps) {
  return (
    <div className="h-100 flex-grow-1 d-flex flex-column justify-content-center align-items-center">
      {withLogo ? (
        <img className="w-50" src={Logo} alt="Côntrol Portal" />
      ) : null}
      <LoadingSpinner className={styles.loading} />
    </div>
  );
}
